import React, { useEffect } from "react";
import "./MapPopup.css";
import "./App.css";
const MapPopup = ({ title, description, src, bullets }) => {
  return (
    <div className="MapPopup">
      <div className="MapPopup-title">{title}</div>
      <div className="MapPopup-content">
        <div className="MapPopup-description">
          {description}
          {bullets != undefined ? (
            <div className="MapPopup-bullets-container">
              <div className="Values">Value:</div>
              <ul className="MapPopup-bullets">
                {bullets.map((bullet, b) => (
                  <li key={b}>{bullet}</li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>

        {src !== undefined ? (
          <div className="MapPopup-icon-container">
            <img className="MapPopup-icon" src={require(`./content/${src}.png`).default}></img>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MapPopup;
